import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

const defaultLng = "en-US";

let lng = defaultLng;
const local = navigator.language;

if (local) {
  lng = local === "en" ? defaultLng : local;
}

if (localStorage.getItem("i18nextLng")) {
  localStorage.removeItem("i18nextLng");
}
i18n
  .use(HttpApi)
  .use(detector)
  .use(initReactI18next)
  .init({
    lng,
    fallbackLng: "en",
    nsSeparator: false,
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath:
        process.env.NODE_ENV && process.env.NODE_ENV.toString() === "development"
          ? `${window.location.hash}/public/localization/${lng}/translation.json`
          : `${window.location.hash}/publics/localization/${lng}/translation.json`,
      allowMultiLoading: true,
    },
    react: {
      wait: true,
      useSuspense: true,
    },
  });
export default i18n;
